import React from 'react';
import { getStatusCopy } from './enquiryDisplay';

const EnquiryStatusPill = ({ status, id }) => {
    const { label, modifier } = getStatusCopy(status);

    return (
        <span id={id} className={`enquiry-status enquiry-status--${modifier}`}>{label}</span>
    );
};

export default EnquiryStatusPill;
